import React from "react";

export default function SettingsOverviewCard({ onOpenSettings }) {
  return (
    <div className="glass parent-card">
      <div className="header-flex">
        <h2>Settings</h2>
      </div>
      <div className="card-body">
        <p style={{ textAlign: "center", opacity: 0.7 }}>
          Manage family setup, templates, integrations, and Pro options in the Settings dashboard.
        </p>
        <button className="btn-nav success-btn" onClick={onOpenSettings} style={{ width: "100%" }}>
          Open Settings
        </button>
      </div>
    </div>
  );
}
